var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerRef",staticClass:"p-pc",class:_vm.scrollHideHeader ? 'scroll' : '',on:{"scroll":_vm.onPageScroll}},[(_vm.isRoute2023)?_c('Headers2023'):_c('Headers'),_c('div',{staticClass:"p-pc-main"},[_c('router-view')],1),_c('Footers'),_c('DynamicDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }